import { createRouter, createWebHistory } from 'vue-router';
import { createApp } from 'vue';
import Home from './pages/HomePage.vue';
import Contact from './pages/ContactUs.vue';
import App from './App.vue';
import  './index.css';
const routes = [
    { path: '/', component: Home },
    { path: '/contact', component: Contact }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

const app = createApp(App)

app.use(router)
app.mount('#app')